import api from "../index"

const wpicds = api.injectEndpoints({
  endpoints: (build) => ({
    getFundRequestsWp: build.query({
      query: (params) => ({
        url: `/wealthPartner/icds/fund-requests`,
        method: "GET",
        params,
      }),
    }),
    showInterestWp: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/icds/show-interest/${id}`,
        method: "POST",
        body,
      }),
    }),
    counterOfferWp: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/wealthPartner/icds/counter-offer/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    IcdRequestsWp: build.query({
      query: (params) => ({
        url: `/wealthPartner/icds/icd-requests`,
        method: "GET",
        params,
      }),
    }),
    viewIcdRequestWp: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/icds/icd-request/view/${id}`,
        method: "GET",
      }),
    }),
    deleteIcdRequestWp: build.mutation({
      query: ({ id }) => ({
        url: `/wealthPartner/icds/icd-request/delete/${id}`,
        method: "DELETE",
      }),
    }),
    createFundRequestWp: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/icds/create`,
        method: "POST",
        body: params,
      }),
    }),
    approveOfferWp: build.mutation({
      query: ({ id }) => ({
        url: `/wealthPartner/icds/approve/${id}`,
        method: "GET",
      }),
    }),
    rejectOfferWp: build.mutation({
      query: ({ id }) => ({
        url: `/wealthPartner/icds/reject/${id}`,
        method: "GET",
      }),
    }),
    icdPaymentWp: build.mutation({
      query: (body) => ({
        url: `/wealthPartner/icds/payment`,
        method: "POST",
        body,
      }),
    }),
    icdPaymentsWp: build.query({
      query: (params) => ({
        url: `/wealthPartner/icds/icd-payments`,
        method: "GET",
        params,
      }),
    }),
  }),
})

export const {
  useLazyGetFundRequestsWpQuery,
  useShowInterestWpMutation,
  useCounterOfferWpMutation,
  useLazyIcdRequestsWpQuery,
  useDeleteIcdRequestWpMutation,
  useLazyViewIcdRequestWpQuery,
  useCreateFundRequestWpMutation,
  useApproveOfferWpMutation,
  useRejectOfferWpMutation,
  useIcdPaymentWpMutation,
  useLazyIcdPaymentsWpQuery,
} = wpicds
